<template>
  <svg
    class="rotate180"
    :class="{dark: darkMode}"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 28 28">
    <path id="Path_449" data-name="Path 449" class="cls-3" d="M1.41,2.64H26.59A1.32,1.32,0,0,0,28,1.41,1.34,1.34,0,0,0,26.76,0H1.41A1.34,1.34,0,0,0,0,1.24a1.32,1.32,0,0,0,1.24,1.4Z" transform="translate(0 0)"/>
    <rect id="Rectangle_4322" data-name="Rectangle 4322" class="first-bar" x="22.12" y="4.71" width="2.8" height="10" rx="1.31"/>
    <rect id="Rectangle_4323" data-name="Rectangle 4323" class="second-bar" x="15.77" y="4.71" width="2.8" height="10" rx="1.31"/>
    <rect id="Rectangle_4324" data-name="Rectangle 4324" class="third-bar" x="9.43" y="4.71" width="2.8" height="10" rx="1.31"/>
    <rect id="Rectangle_4325" data-name="Rectangle 4325" class="forth-bar" x="3.08" y="4.71" width="2.8" height="10" rx="1.23"/>
  </svg>

</template>

<script>
export default {
  name: 'ChartLoader',
  props: {
    darkMode: {
      type: Boolean,
      required: false,
      dafault: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.rotate180 {
  transform: rotate(180deg);
}

path, rect {
  fill: #ced6d9;
}

.dark {
  path, rect {
    fill: #748991;
  }
}

.first-bar, .second-bar, .third-bar, .forth-bar {
  animation-iteration-count: infinite;
}

.first-bar {
  animation: raiser 1.2s;
  animation-iteration-count: infinite;
}

.second-bar {
  animation: raiser 1.4s;
  animation-iteration-count: infinite;
  animation-delay: 0.3s;
}

.third-bar {
  animation: raiser 1.65s;
  animation-iteration-count: infinite;
  animation-delay: 0.45s;
}

.forth-bar {
  animation: raiser 1.3s;
  animation-iteration-count: infinite;
  animation-delay: 0.15s;
}

@keyframes raiser {
  0% { height: 10px; }
  50% { height: 20px; }
  100% { height: 10px; }
}
</style>
